import React, { useState } from 'react';

import Seo from '../components/seo/Seo';
import ServicesHero from '../components/services/ServicesHero';
import ServicesSummary from '../components/services/ServicesSummary';
import ServicesPrecisionControl from '../components/services/ServicesPrecisionControl';
import ServicesGreenEnergy from '../components/services/ServicesGreenEnergy';
import ServicesFabricationMechanical from '../components/services/ServicesFabricationMechanical';
import ServicesTechnical from '../components/services/ServicesTechnical';
import ServicesElectrical from '../components/services/ServicesElectrical';
import ServicesMaintenanceRefrigerationSafety from '../components/services/ServicesMaintenanceRefrigerationSafety';

export default function Services(): React.ReactElement {
  const [selectedService, setSelectedService] = useState<string | null>(null);

  const handleServiceClick = (serviceId: string) => {
    setSelectedService(serviceId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBack = () => {
    setSelectedService(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderServiceDetail = () => {
    switch (selectedService) {
      case 'automation':
        return <ServicesPrecisionControl onBack={handleBack} />;
      case 'green-energy':
        return <ServicesGreenEnergy onBack={handleBack} />;
      case 'fabrication':
        return <ServicesFabricationMechanical onBack={handleBack} />;
      case 'technical':
        return <ServicesTechnical onBack={handleBack} />;
      case 'electrical':
        return <ServicesElectrical onBack={handleBack} />;
      case 'maintenance-refrigeration-safety':
        return <ServicesMaintenanceRefrigerationSafety onBack={handleBack} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Seo
        title="Our Services - Industrial Automation, Solar PV, Fabrication & ICT | Ancient Engineering"
        description="Comprehensive engineering services in Zimbabwe: Industrial Automation & Control, Green Energy Solutions (Solar PV), Fabrication & Mechanical, and Technical Services, ICT & Security."
        keywords="engineering services Zimbabwe, industrial automation services, solar PV installation Zimbabwe, fabrication services Zimbabwe, mechanical engineering services, ICT security Zimbabwe"
        ogTitle="Our Services - Ancient Engineering"
        ogDescription="Comprehensive engineering services: Industrial Automation, Solar PV, Fabrication & Mechanical, and ICT & Security in Zimbabwe."
        canonical="https://www.ancientengineering.co.zw/services"
      />
      <ServicesHero />
      {selectedService ? renderServiceDetail() : <ServicesSummary onServiceClick={handleServiceClick} />}
    </>
  );
}
